export const INTRO_CONSTANTS = {
  title: "Next-Gen Cyber Security",
  text: "Cyber threats today are faster, stealthier, and more complex than ever. OneMind delivers a unified cybersecurity approach through Endpoint (EDR), Managed (MDR), and Extended (XDR) Detection and Response — all powered by AI and real-time automation. ",
  highlight: ["EDR", "MDR", "XDR"],
};
